export const Archive = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.666504 2.50948C0.666504 1.85973 1.21371 1.33301 1.88873 1.33301H14.1109C14.786 1.33301 15.3332 1.85973 15.3332 2.50948C15.3332 3.15923 14.786 3.68596 14.1109 3.68596H1.88873C1.21371 3.68596 0.666504 3.15923 0.666504 2.50948ZM2.29613 4.47026H13.7036V13.4899C13.7036 14.1396 13.1564 14.6663 12.4813 14.6663H3.51835C2.84334 14.6663 2.29613 14.1396 2.29613 13.4899V4.47026ZM5.11908 10.8399C4.80088 11.1462 4.80088 11.6428 5.11908 11.9491C5.43729 12.2554 5.9532 12.2554 6.2714 11.9491L8.00002 10.2852L9.72879 11.9493C10.047 12.2556 10.5629 12.2556 10.8811 11.9493C11.1993 11.643 11.1993 11.1464 10.8811 10.8401L9.15234 9.17602L10.8807 7.51238C11.1989 7.20608 11.1989 6.70948 10.8807 6.40318C10.5625 6.09689 10.0466 6.09689 9.72837 6.40318L8.00002 8.06684L6.27182 6.40333C5.95362 6.09703 5.43771 6.09703 5.1195 6.40333C4.80131 6.70962 4.80131 7.20622 5.1195 7.51252L6.8477 9.17602L5.11908 10.8399Z'
      fill='inherit'
    />
  </svg>
);

export const ArchiveBig = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 4C3.44772 4 3 4.44772 3 5V6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6V5C21 4.44772 20.5523 4 20 4H4ZM19 8H5V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V8Z'
      fill='#94A3B8'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.46477 16.1216C8.07424 16.5121 8.07424 17.1453 8.46477 17.5358C8.85529 17.9264 9.48846 17.9264 9.87898 17.5358L12.0003 15.4145L14.1217 17.5358C14.5122 17.9264 15.1454 17.9264 15.5359 17.5358C15.9264 17.1453 15.9264 16.5121 15.5359 16.1216L13.4146 14.0003L15.5358 11.879C15.9264 11.4885 15.9264 10.8553 15.5358 10.4648C15.1453 10.0742 14.5121 10.0742 14.1216 10.4648L12.0003 12.5861L9.87905 10.4648C9.48853 10.0742 8.85536 10.0742 8.46484 10.4648C8.07431 10.8553 8.07431 11.4885 8.46484 11.879L10.5861 14.0003L8.46477 16.1216Z'
      fill='white'
    />
  </svg>
);

export const Archive16 = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 3.66602C2 3.11373 2.44772 2.66602 3 2.66602H13C13.5523 2.66602 14 3.11373 14 3.66602C14 4.2183 13.5523 4.66602 13 4.66602H3C2.44772 4.66602 2 4.2183 2 3.66602ZM3.33333 5.33268H12.6667V12.9993C12.6667 13.5516 12.219 13.9993 11.6667 13.9993H4.33333C3.78105 13.9993 3.33333 13.5516 3.33333 12.9993V5.33268ZM5.64302 10.7469C5.38267 11.0072 5.38267 11.4294 5.64302 11.6897C5.90337 11.9501 6.32548 11.9501 6.58582 11.6897L8.00015 10.2754L9.4146 11.6898C9.67495 11.9502 10.0971 11.9502 10.3574 11.6898C10.6178 11.4295 10.6178 11.0074 10.3574 10.747L8.94296 9.33257L10.3571 7.91847C10.6174 7.65812 10.6174 7.23601 10.3571 6.97566C10.0967 6.71531 9.6746 6.71531 9.41425 6.97566L8.00015 8.38976L6.58617 6.97578C6.32582 6.71543 5.90371 6.71543 5.64336 6.97578C5.38302 7.23613 5.38302 7.65824 5.64336 7.91859L7.05734 9.33257L5.64302 10.7469Z'
      fill='inherit'
    />
  </svg>
);

export const ArchiveStatus = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 4C3.44772 4 3 4.44772 3 5V6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6V5C21 4.44772 20.5523 4 20 4H4ZM19 8H5V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V8Z'
      fill='#94A3B8'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.46477 16.1216C8.07424 16.5121 8.07424 17.1453 8.46477 17.5358C8.85529 17.9264 9.48846 17.9264 9.87898 17.5358L12.0003 15.4145L14.1217 17.5358C14.5122 17.9264 15.1454 17.9264 15.5359 17.5358C15.9264 17.1453 15.9264 16.5121 15.5359 16.1216L13.4146 14.0003L15.5358 11.879C15.9264 11.4885 15.9264 10.8553 15.5358 10.4648C15.1453 10.0742 14.5121 10.0742 14.1216 10.4648L12.0003 12.5861L9.87905 10.4648C9.48853 10.0742 8.85536 10.0742 8.46484 10.4648C8.07431 10.8553 8.07431 11.4885 8.46484 11.879L10.5861 14.0003L8.46477 16.1216Z'
      fill='white'
    />
  </svg>

  // <svg
  //   style={{ ...props?.style }}
  //   width='12'
  //   height='12'
  //   viewBox='0 0 12 12'
  //   fill='#94A3B8'
  //   xmlns='http://www.w3.org/2000/svg'
  // >
  //   <path
  //     fillRule='evenodd'
  //     clipRule='evenodd'
  //     d='M0 1.66669C0 1.1144 0.447715 0.666687 1 0.666687H11C11.5523 0.666687 12 1.1144 12 1.66669C12 2.21897 11.5523 2.66669 11 2.66669H1C0.447715 2.66669 0 2.21897 0 1.66669ZM1.33333 3.33335H10.6667V11C10.6667 11.5523 10.219 12 9.66667 12H2.33333C1.78105 12 1.33333 11.5523 1.33333 11V3.33335ZM3.64302 8.74757C3.38267 9.00792 3.38267 9.43003 3.64302 9.69037C3.90337 9.95072 4.32548 9.95072 4.58582 9.69038L6.00015 8.27605L7.4146 9.6905C7.67495 9.95085 8.09706 9.95085 8.35741 9.6905C8.61776 9.43015 8.61776 9.00804 8.35741 8.74769L6.94296 7.33324L8.35706 5.91914C8.61741 5.65879 8.61741 5.23668 8.35706 4.97633C8.09671 4.71598 7.6746 4.71598 7.41425 4.97633L6.00015 6.39043L4.58617 4.97645C4.32582 4.7161 3.90371 4.7161 3.64336 4.97645C3.38302 5.2368 3.38302 5.65891 3.64336 5.91926L5.05734 7.33324L3.64302 8.74757Z'
  //     fill='inherit'
  //   />
  // </svg>
);
